/** Erreur retournée par l'API Geolocation d'après les spécification W3C. */
export enum EGeoApiPositionError {

	/** Le processus d'acquisition a échoué car les permissions ne sont pas suffisantes. */
	PERMISSION_DENIED = 1,
	/** Impossible de déterminer la position. Une erreur a été retournée par un des processus internes nécessaires à l'acquisition de la position. */
	POSITION_UNAVAILABLE = 2,
	/** Le temps maximal alloué a été dépassé avant que la demande ne puisse aboutir. */
	TIMEOUT = 3
}